import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { handleError } from '../../../contexts/ErrorHandler/errorHandlerPropsMap';
import { IChallengeContext } from '../../../contexts/storage-contexts/Challenge';
import { goToVisitorPage } from './goToVisitorPage';
import { prepareUserForPayment } from './prepareUserForPayment';
import { renderSeoMetatagsPage } from '../../../services/SeoMetatagsPage';

export const createOrderOrSendJoinRequest = async ({
  initialProps,
  flowAPI,
}: {
  initialProps: Partial<IChallengeContext>;
  flowAPI: ControllerFlowAPI;
}) => {
  flowAPI.controllerConfig.setProps({
    isForcedBlankPage: true,
  });
  try {
    const userWithOrder = await prepareUserForPayment(flowAPI);

    // userWithOrder is null if we just sent join request
    // so redirect to the visitor page
    if (!userWithOrder) {
      goToVisitorPage({
        challengeData: initialProps.challengeData,
        flowAPI,
      });
      return;
    }

    flowAPI.controllerConfig.setProps({
      ...initialProps,
      ...userWithOrder,
      isForcedBlankPage: false,
    });

    renderSeoMetatagsPage(
      flowAPI,
      initialProps?.challengeData?.challenge,
      'PAYMENT_PAGE',
    );
  } catch (err) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(err);
    handleError({
      error: err,
      resolvedError,
    });
  }
};
